import styled from 'styled-components'

import theme from '../../theme'

const CardWrapper = styled.div`
  width: 100%;

  &.disabled,
  &.disabled .ant-card {
    background-color: ${theme.colors.white};
    opacity: 0.3;
    cursor: not-allowed !important;
  }

  .ant-card {
    flex: 40%;
    width: 100%;
    border-radius: 4px;
    &:hover {
      cursor: pointer;
    }
    .ant-card-head {
      border-bottom: 0px;
      font-size: 14px;
      font-weight: 600;
      padding: 0px 12px;
      min-height: 38px;

      .ant-card-head-wrapper {
        align-items: flex-start !important;
      }

      .ant-card-head-title,
      .ant-card-extra {
        padding: 8px 0;
      }

      .ant-card-head-title {
        padding-right: 8px !important;
        white-space: normal !important;
      }
      .ant-card-extra {
      }
    }

    .ant-card-body {
      padding: 0 12px 8px;
      color: ${theme.colors.gray8};
    }
  }
`

export { CardWrapper }
